import { buildReturnTarget, RETURN_TARGET_STATE_KEY } from './returnTarget'

const ACCESS_TOKEN_QUERY_PARAM = 'access_token'

function parseStateParamValue(value: string): string | number | boolean {
  const parsedNumber = Number(value)
  if (!Number.isNaN(parsedNumber) && value.trim() !== '') {
    return parsedNumber
  }

  if (value === 'true' || value === 'false') {
    return value === 'true'
  }

  return value
}

export function buildEntraAuthUrl(queryParams: URLSearchParams): string {
  const stateObject: Record<string, string | number | boolean> = {}

  queryParams.forEach((value, key) => {
    if (key === ACCESS_TOKEN_QUERY_PARAM) {
      return
    }

    stateObject[key] = parseStateParamValue(value)
  })

  // Set after the query params so a `?__returnTo=` in the link cannot win.
  stateObject[RETURN_TARGET_STATE_KEY] = buildReturnTarget(window.location)

  const state = encodeURIComponent(JSON.stringify(stateObject))
  const clientId =
    import.meta.env.VITE_ENTRA_CLIENT_ID ||
    import.meta.env.VITE_TOKEN_CLIENT_ID ||
    ''
  const tenantDomain =
    import.meta.env.VITE_ENTRA_TENANT_DOMAIN || 'suitsupply.com'
  const redirectUri =
    import.meta.env.VITE_ENTRA_REDIRECT_URI ||
    `${window.location.origin}/auth/callback`

  if (!clientId) {
    throw new Error(
      'Missing Entra client id. Set VITE_ENTRA_CLIENT_ID (or VITE_TOKEN_CLIENT_ID) in your environment.',
    )
  }

  const authUrl = new URL(
    `https://login.microsoftonline.com/${tenantDomain}/oauth2/authorize`,
  )
  authUrl.searchParams.set('response_type', 'token')
  authUrl.searchParams.set('client_id', clientId)
  authUrl.searchParams.set('redirect_uri', redirectUri)
  authUrl.searchParams.set('state', state)
  authUrl.searchParams.set('resource', clientId)
  authUrl.searchParams.set('scope', 'User.Read')

  return authUrl.toString()
}
